import {NavLink} from "react-router-dom";
import {Fragment, useState} from "react";
import {QuillDeltaToHtmlConverter} from "quill-delta-to-html";
import SmallSpinner from "../SmallSpinner";

function sanitizeFileNamePart(s) {
	return (s || '').replace(/[^a-zA-Z0-9_-]+/g, '_').replace(/^_+|_+$/g, '') || 'project';
}

function CustomerTaskRow({customerTask, freelancerInvoiceDateFrom, freelancerInvoiceDateTo}) {
	const [exporting, setExporting] = useState(false);
	let comments = null;
	try {
		comments = new QuillDeltaToHtmlConverter(JSON.parse(customerTask.comments)).convert();
	}
	catch (e) {

	}

	async function exportRow() {
		if (parseFloat(customerTask.externalCostsInvoicedByFreelancers) <= 0) return;
		try {
			setExporting(true);
			const params = new URLSearchParams();
			params.append('customerTaskId', customerTask.id);
			if (freelancerInvoiceDateFrom) params.append('freelancerInvoiceDateFrom', freelancerInvoiceDateFrom);
			if (freelancerInvoiceDateTo) params.append('freelancerInvoiceDateTo', freelancerInvoiceDateTo);

			const response = await fetch(process.env.REACT_APP_endPoint + '/v1/customerTasks/exportExternalCostsInvoicedByFreelancersDetails?' + params.toString(), {
				method: "GET",
				credentials: "include",
			});
			const blob = await response.blob();
			const uri = URL.createObjectURL(blob);
			const datestart = freelancerInvoiceDateFrom || 'all';
			const dateend = freelancerInvoiceDateTo || 'all';
			const link = document.createElement("a");
			link.download = `${sanitizeFileNamePart(customerTask.name)}_invoiced_by_FL_${datestart}_${dateend}.tsv`;
			link.href = uri;
			link.click();
			link.remove();
		}
		catch (e) {
			console.error(e);
		}
		finally {
			setExporting(false);
		}
	}

	const clickable = parseFloat(customerTask.externalCostsInvoicedByFreelancers) > 0;

	return (
		<tr>
			<td>{customerTask.customer}</td>
			<td>{customerTask.billingEntityName}</td>
			<td>{customerTask.code}</td>
			<td><NavLink to={'/customerTasks/' + customerTask.id}>{customerTask.name}</NavLink></td>
			<td>{customerTask.description}</td>
			<td>{customerTask.status}</td>
			<td>{customerTask.externalCosts ? <Fragment>&euro;{customerTask.externalCosts.toLocaleString()}</Fragment>: 'N.A.'}</td>
			<td
				onClick={clickable ? exportRow : undefined}
				style={clickable ? {cursor: "pointer", color: "#0d6efd", textDecoration: "underline"} : undefined}
				title={clickable ? "Click to download details for this project" : undefined}>
				{customerTask.externalCostsInvoicedByFreelancers ? <Fragment>&euro;{customerTask.externalCostsInvoicedByFreelancers.toLocaleString()}</Fragment>: 'N.A.'}
				{exporting && <Fragment> <SmallSpinner /></Fragment>}
			</td>
			<td>{customerTask.estimatedInvoiceValue ? <Fragment>
					{customerTask.currencyName === "EUR" && <>&euro;</>}
					{customerTask.currencyName === "USD" && <>&#36;</>}
					{customerTask.currencyName === "PLN" && <>P</>}
					{customerTask.estimatedInvoiceValue.toLocaleString()}</Fragment>: "N.A."}
			</td>
			<td>{customerTask.expectedDueDate}</td>
			<td>{customerTask.poNumber}</td>
			<td>{customerTask.invoiceAmount ? <Fragment>&euro;{customerTask.invoiceAmount.toLocaleString()}</Fragment>: 'N.A.'}</td>
			<td>{customerTask.finalAmount ? <Fragment>
				{customerTask.currencyName === "EUR" && <>&euro;</>}
				{customerTask.currencyName === "USD" && <>&#36;</>}
				{customerTask.currencyName === "PLN" && <>P</>}
				{customerTask.finalAmount.toLocaleString()}</Fragment>: "N.A."}</td>
			<td>{customerTask.invoiceDate}</td>
			<td>{customerTask.invoiceNumber}</td>
			<td>{customerTask.invoiced ? <input type={"checkbox"} checked={true} disabled={true} />: <input disabled={true} type={"checkbox"} checked={false} />}</td>
			<td>{customerTask.nonBillable ? <input type={"checkbox"} checked={false} disabled={true} />: <input disabled={true} type={"checkbox"} checked={true} />}</td>
		</tr>
	);
}

export default CustomerTaskRow;
